export default __webpack_public_path__ + "static/media/Arnold_C94EF019751DA.149edf23.jpg";